//Note: it's important to wrap the actual element you want to animate with a wrapper element because the padding of your element will mess up the look if you don't

document.addEventListener("DOMContentLoaded", () => {
  Array.from(document.querySelectorAll(".sliding-element:not(.show)")).forEach(hiddenSlidingEl => {
    hiddenSlidingEl.style.setProperty('display', 'none', 'important');
  });
});

//The show parameter is optional and the function will act like a toggle if it's not passed
function slidingElementAnimation(elementWrapper, show) {
  const isCurrentlyShown = elementWrapper.classList.contains("show");

  //If no show value was provided then act like a toggle
  if (show === undefined) show = !isCurrentlyShown;
  
  //Wether we animate the width or the height depending on the animation style chosen
  const styleToAnimate = elementWrapper.classList.contains("top-to-bottom") || elementWrapper.classList.contains("bottom-to-top") ? "height" : "width";
  
  //Show the display
  if (show !== false) {
    //only run it if it's not already showing
    if (isCurrentlyShown) return;
    elementWrapper.dispatchEvent(new CustomEvent("slidingAnimation:show"));
    elementWrapper.dispatchEvent(new CustomEvent("slidingAnimation:toggle", {detail: "show" }));
    elementWrapper.style.display = "";
    elementWrapper.classList.remove("d-none");
    
    //Peeking at what the final style will be and saving it
    elementWrapper.style[styleToAnimate] = "";
    const styleValue = elementWrapper.offsetHeight; 
    elementWrapper.style[styleToAnimate] = "0";
    //Skipping 2 animations frames to make the transition have the time to register that the height is back to 0 before changing the height again
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        elementWrapper.addEventListener("transitionend",() => {
          elementWrapper.style[styleToAnimate] = "";
        }, {once: true});
        elementWrapper.classList.add("show");
        elementWrapper.style[styleToAnimate] = styleValue + "px";
        elementWrapper.style.margin = "";
      });
    });
  }
  //Hide the display (only run it if it's currently showing)
  else if (isCurrentlyShown){
    elementWrapper.dispatchEvent(new CustomEvent("slidingAnimation:hide"));
    elementWrapper.dispatchEvent(new CustomEvent("slidingAnimation:toggle", {detail: "hide" }));
    elementWrapper.style[styleToAnimate] = elementWrapper.offsetHeight + "px";
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        elementWrapper.addEventListener("transitionend",() => {
          elementWrapper.style[styleToAnimate] = "";
          elementWrapper.style.setProperty('display', 'none', 'important');
        }, {once: true});
        elementWrapper.classList.remove("show");
        elementWrapper.style[styleToAnimate] = "0";
        elementWrapper.style.margin = "0";
      });
    });
  }
}
